import axios from "../../axios";

const getTransaction = async function (accessToken,uuid = {}) {
    try {
        const response = await axios.get('admin/pay-in/getTransaction',{
            headers: {
                'Authorization': accessToken
            },
            params: {
                uuid
            }
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response.status
        }
    }
}

export default getTransaction;
